import { Reveal, Eyebrow } from "./shared";

const CHAPTERS = [
  {
    num: "01",
    title: "Craftsmanship",
    body: "Straight lines. Square corners. Materials we'd use on our own houses. Every cut, every seam, every coat of paint gets checked by the owner before you ever see it.",
  },
  {
    num: "02",
    title: "Transparency",
    body: "A written scope before a shovel hits dirt. An itemized estimate with no surprise line items. You'll know what's happening this week, next week, and what it costs.",
  },
  {
    num: "03",
    title: "Structural Integrity",
    body: "Permitted, inspected, and built to code — then built past it. We don't cover problems; we prevent them, because our name goes on every job we sign.",
  },
];

export default function Manifesto() {
  return (
    <section data-testid="manifesto-section" className="py-20 md:py-32 relative">
      <div className="max-w-[1440px] mx-auto px-4 sm:px-8 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-4">
            <Reveal>
              <Eyebrow>The TCB Standard</Eyebrow>
            </Reveal>
            <Reveal delay={0.08}>
              <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl uppercase leading-[0.95] tracking-tight text-bone mt-5">
                Three things we never cut
              </h2>
            </Reveal>
            <Reveal delay={0.16}>
              <p className="text-steel text-base leading-relaxed mt-6 max-w-sm">
                Anyone can swing a hammer. Here's what separates a TCB job from the rest of the bids on your kitchen table.
              </p>
            </Reveal>
          </div>

          <div className="lg:col-span-8 flex flex-col">
            {CHAPTERS.map((c, i) => (
              <Reveal key={c.num} delay={i * 0.08}>
                <div
                  data-testid={`manifesto-chapter-${c.num}`}
                  className="group flex flex-col sm:flex-row gap-6 sm:gap-10 py-9 border-t border-line last:border-b transition-colors duration-300 hover:bg-ink-card/50 px-2 sm:px-6"
                >
                  <span className="font-display text-5xl sm:text-6xl text-outline group-hover:text-safety group-hover:[-webkit-text-stroke:0px] transition-all duration-300 leading-none">
                    {c.num}
                  </span>
                  <div className="flex-1">
                    <h3 className="font-cond font-bold uppercase text-2xl sm:text-3xl tracking-wide text-bone">{c.title}</h3>
                    <p className="text-steel text-base leading-relaxed mt-3 max-w-2xl">{c.body}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
